// extracted by mini-css-extract-plugin
module.exports = {"overlay":"darkoverlay_overlay__Ryl7h","fadein":"darkoverlay_fadein__70Tbd","open":"darkoverlay_open__HnNCg","loading":"darkoverlay_loading__mXNlO"};